import { render, staticRenderFns } from "./EditSeafaringPractice.vue?vue&type=template&id=4a4fe042"
import script from "./EditSeafaringPractice.vue?vue&type=script&lang=ts"
export * from "./EditSeafaringPractice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports